import { Injectable } 		        from '@angular/core';
import { Router, CanActivate }		from '@angular/router';
import { of }                     from 'rxjs';
import { StsPortalStatus }        from '../models/sts-portal-status';
import { StsPortalStatusService } from './sts-portal-status.service';
import { map, catchError }        from 'rxjs/operators';

// Redirects user to main page if already authenticated in portal
//
@Injectable()
export class StsRouteRequiresUnauth implements CanActivate {

  constructor(private stsPortalStatusService: StsPortalStatusService, private router: Router) {
  }

  canActivate() {
    return this.stsPortalStatusService.getPortalStatus().pipe(
      map((portalStatus: StsPortalStatus) => {
        if (portalStatus && portalStatus.isLoggedIn && (!portalStatus.tfa || portalStatus.tfa.status.match(/2fa/ig) == null)) {
          console.log('User already logged in, redirecting to home page!');
          window.location.href = '/';
          return false;
        }
        return true;
     }),
     catchError((err) => {
        console.log('Unable to verify portal authentication status, allowing route to proceed!');
        return of(true);
     })
    );
  }

}
